import { AfterViewInit, Directive, TemplateRef, ViewContainerRef } from '@angular/core';

/**
 * Les éléments dsd-footnote prennent la valeur du dsd-footnote-ref. Dans certains cas, le rendering ne se
 * fait pas dans le bon ordre et le texte hors écran du dsd-footnote est vide. Cette directive force le render
 * du footnote après que la page soit chargée
 */
@Directive({
  selector: '[dsdExtFootnoteScreenReaderFix]',
  standalone: false
})
export class FootnoteScreenReaderFixDirective implements AfterViewInit {
  constructor(private readonly templateRef: TemplateRef<any>, private readonly viewContainer: ViewContainerRef) {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }, 250);
  }
}
